export const tenantViewCheck = {
  path: '/api/v1/tenants',
  method: 'GET',
};

export const macViewCheck = {
  path: '/api/v1/macs',
  method: 'GET',
};

export const tenantCreateCheck = {
  path: '/api/v1/tenants',
  method: 'POST',
};

export const tenantEditCheck = {
  path: '/api/v1/tenants',
  method: 'PUT',
};

export function searchTenants(search, contentType) {
  return {
    accept: contentType,
    path: `tenants${search}`,
  };
}

export function createTenant(body) {
  return {
    path: 'tenants',
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function getTenant(tenantId, query = '') {
  return {
    path: `tenants/${tenantId}${query}`,
    method: 'GET',
  };
}

export function updateTenant(tenantId, body) {
  return {
    path: `tenants/${tenantId}`,
    method: 'PUT',
    body: JSON.stringify(body),
  };
}

export function getTenantSubscription(tenantId) {
  return {
    path: `tenants/${tenantId}/subscription`,
    method: 'GET',
    skipBodyCheck: true,
  };
}

export function getTenantUnit(tenantId) {
  return {
    path: `tenants/${tenantId}/unit`,
    method: 'GET',
    skipBodyCheck: true,
  };
}

export function getTenantLocationHistory(tenantId) {
  return {
    path: `tenants/${tenantId}/unit/history`,
    method: 'GET',
  };
}

export function getTenantBuilding(tenantId) {
  return {
    path: `tenants/${tenantId}/building`,
    method: 'GET',
    skipBodyCheck: true,
  };
}

export function getTenantMacs(search, contentType, tenantId) {
  return {
    path: `tenants/${tenantId}/macs${search}`,
    method: 'GET',
    accept: contentType,
  };
}

export function createTenantUnitReference(tenantId, unitId, createdBy) {
  return {
    path: `tenants/${tenantId}/unit`,
    method: 'PUT',
    body: JSON.stringify({ unit_id: unitId, created_by: createdBy }),
  };
}

export function sendTenantWelcomeEmail(tenantId) {
  return {
    path: 'welcome_email/tenant',
    method: 'POST',
    body: JSON.stringify({ tenant_id: tenantId }),
  };
}

export function getTenantSatellite(tenantId) {
  return {
    path: `tenants/${tenantId}/satellite`,
    skipBodyCheck: true,
  };
}

export function deleteTenantSatellite(tenantId) {
  return {
    path: `tenants/${tenantId}/satellite`,
    method: 'DELETE',
  };
}

export function createTenantSatellite(tenantId, body) {
  return {
    path: `tenants/${tenantId}/satellite`,
    body: JSON.stringify({
      tenant_id: tenantId,
      ...body,
    }),
    method: 'POST',
  };
}

export function updateTenantSatellite(tenantId, body) {
  return {
    path: `tenants/${tenantId}/satellite`,
    body: JSON.stringify(body),
    method: 'PUT',
  };
}
